export type DisplayContext = 'before_login' | 'after_login' | 'both';

export interface BannerItem {
  id: string;
  name: string;
  imageUrl: string;
  linkUrl: string | null;
  /** Player-facing copy shown with the image; absent on rows saved before #574. */
  title?: string | null;
  subtitle?: string | null;
  description?: string | null;
  displayContext?: DisplayContext | null;
  priority: number;
}

/** 'both' is the fallback for anything unrecognised — never hide by accident. */
export function matchesDisplayContext(
  value: DisplayContext | null | undefined,
  authed: boolean,
): boolean {
  if (value === 'before_login') return !authed;
  if (value === 'after_login') return authed;
  return true;
}

/**
 * The banners eligible for this visitor, highest priority first. The home hero
 * shows only the first; the BO help copy says so in all seven languages.
 */
export function selectBannersToShow(
  items: BannerItem[],
  opts: { authed: boolean },
): BannerItem[] {
  return items
    .filter((b) => matchesDisplayContext(b.displayContext, opts.authed))
    .sort((a, b) => b.priority - a.priority);
}
